export const getCompanies = (products) => {
  const companies = new Set();
  let n = products.length;
  for (let i = 0; i < n; i++) {
    companies.add(products[i]["company"]);
  }
  return Array.from(companies);
};

export const getCategories = (products) => {
  const categories = new Set();
  let n = products.length;
  for (let i = 0; i < n; i++) {
    categories.add(products[i]["category"]);
  }
  return Array.from(categories);
};

export const getColors = (products) => {
  const colors = new Set();
  let n = products.length;
  for (let i = 0; i < n; i++) {
    for (let j = 0; j < products[i]["colors"].length; j++) {
      colors.add(products[i]["colors"][j]);
    }
  }
  return Array.from(colors);
};

export const getMaximumPrice = (products) => {
  let max = products === [] ? 0 : products[0]["price"];
  for (let i = 1; i < products.length; i++) {
    if (products[i]["price"] > max) {
      max = products[i]["price"];
    }
  }
  return max;
};

export const filter = (filters, products) => {
  const filteredProducts = [];
  products.forEach((product, index) => {
    const nameCheck = filters.name
      ? product.name.toLowerCase().startsWith(filters.name.toLowerCase())
      : true;
    const categoryCheck = filters.category
      ? product.category === filters.category
      : true;
    const companyCheck = filters.company
      ? product.company === filters.company
      : true;
    const shippingCheck = filters.shipping ? product.shipping : true;
    const colorCheck = filters.color
      ? product.colors.includes(filters.color)
      : true;
    const priceCheck = product.price <= filters.price;

    if (
      nameCheck &&
      categoryCheck &&
      companyCheck &&
      shippingCheck &&
      colorCheck &&
      priceCheck
    ) {
      filteredProducts.push(product);
    }
  });
  return filteredProducts;
};

export const sortData = (products, type) => {
  const sortedProducts = [...products];
  switch (type) {
    case "price_ascending":
      return sortedProducts.sort((a, b) => a.price - b.price);
    case "price_descending":
      return sortedProducts.sort((a, b) => b.price - a.price);

    case "name_ascending":
      return sortedProducts.sort((a, b) => {
        if (a.name > b.name) {
          return 1;
        }
        return -1;
      });
    case "name_descending":
      return sortedProducts.sort((a, b) => {
        if (a.name < b.name) {
          return 1;
        }
        return -1;
      });

    default:
      return sortedProducts;
  }
};
